module.exports = __webpack_public_path__ + "static/media/hhe.f1452af4.mp3";